"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const products_1 = require("@/store/ducks/products");
const selectors_1 = require("@/store/ducks/products/selectors");
const deleteProductUseCase_1 = require("@/useCases/products/deleteProductUseCase");
const index_view_1 = __importDefault(require("./index.view"));
function ProductsDialogAlert() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isDialogVisible = (0, react_redux_1.useSelector)(selectors_1.isDeleteAlertDialogShownSelector);
    const productToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.productToBeDeletedSelector);
    const rowIndexToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.rowIndexToBeDeletedSelector);
    const onClose = react_1.default.useCallback(() => {
        dispatch((0, products_1.closeDeleteProductModal)());
    }, [products_1.closeDeleteProductModal]);
    const onProceed = react_1.default.useCallback(() => {
        (0, deleteProductUseCase_1.removeProduct)(productToBeDeleted?.id)(dispatch);
    }, [rowIndexToBeDeleted, productToBeDeleted, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: isDialogVisible, onClose: onClose, onDismiss: onClose, productNameToBeDeleted: productToBeDeleted?.name, onProceed: onProceed }));
}
exports.default = react_1.default.memo(ProductsDialogAlert);
